
class AttachmentsModel {
  constructor(n) {
    // determine attachment count
    this._count = parseInt(n.metaData['media-attachments-count'], 10)
    if (isNaN(this._count)) {
      this._count = 0
    }
    // mobile doesn't supply this property, so we need to
    // calculate ourselves
    if (n.metaData['media-url'] && this._count === 0) {
      for (let i = 0; i < 10; i++) {
        const suffix = i === 0 ? '' : `-${i+1}`
        if (n.metaData[`media-url${suffix}`] != null) {
          this._count += 1
        }
      }
    }
    // break out the attachments
    this.all = []
    for (let i = 0; i < this._count; i++) {
      const suffix = i === 0 ? '' : `-${i+1}`
      const attModel = new AttachmentModel(i+1, suffix, n)
      if ((attModel.mediaType || '') !== '') {
        this.all.push(attModel)
      }
    }

  }

  firstWithPattern(pattern) {
    const all_lps = this.all.filter(v => v.url.indexOf(pattern) >= 0)
    return all_lps.length === 0 ? null : all_lps[0]
  }

  livePhotoScreenshot() {
    return this.firstWithPattern('livephoto-screenshot')
  }

  livePhotoVideo() {
    return this.firstWithPattern('livephoto-video')
  }

  hasLivePhoto () {
    if (this.all.length < 2) return false
    const livePhotos = this.livePhotoScreenshot()
    const liveVideos = this.livePhotoVideo()
    return livePhotos != null && liveVideos != null
  }
}

class AttachmentModel {
  constructor(index, suffix, n) {
    this.index = index
    this.suffix = suffix
    this.mediaType = n.metaData[`media-content-type${suffix}`]
    this.url = Att.url(n.metaData[`media-url${suffix}`])
    this.meta = n.metaData
    this.size = n.metaData[`media-content-length${suffix}`]
    if (this.size != null) {
      this.size = parseFloat(this.size)
    }
  }
}

class Att {

  static url (mediaUrl) {
    const forPath = mediaUrl.replace(/\\/g, '/').split('/').map(f => encodeURIComponent(f)).join('/')
    return `/att/${forPath}`
  }

  static fileName (mediaUrl) {
    return mediaUrl.split('\\').reverse()[0]
  }

  static parse (n) {
    return new AttachmentsModel(n)
  }

  static count (n) {
    if (!n || !n.metaData) return 0
    // desktop
    const res = parseInt(n.metaData['media-attachments-count'], 10)
    if (!isNaN(res)) return res
    // mobile counting
    let count = 0
    for (let i = 0; i < 20; i++) {
      if (n.metaData[`media-url${i === 0 ? '' : `-${i+1}`}`]) {
        count += 1
        continue
      }
      // as soon as one isn't found, break
      break
    }
    return count
  }

  static url_by_media_type (n, needed) {
    if (!n || !n.metaData) return null
    if (!n.metaData['media-attachments-count']) return null
    const numOfAtt = parseInt(n.metaData['media-attachments-count'], 10)
    for (let i = 0; i < numOfAtt; i++) {
      const suffix = i === 0 ? '' : `-${i+1}`
      const mediaType = n.metaData[`media-content-type${suffix}`]
      if (mediaType === needed) {
        return this.url(n.metaData[`media-url${suffix}`])
      }
    }
    return null // not found
  }
  
}

export default Att;